module.exports = __webpack_public_path__ + "img/4262d4b.png";